import { useEffect, useMemo, useState } from 'react'
import useStore from '../store/useStore'

export interface ImpersonationSessionView {
  isImpersonating: boolean
  sessionId: string | null
  impersonatorName: string | null
  targetName: string | null
  expiresAt: number | null
  isExpired: boolean
  remainingMs: number
}

const useImpersonationSession = (): ImpersonationSessionView => {
  const session = useStore((state) => state.impersonationSession)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!session) return
    const interval = setInterval(() => setTick((value) => value + 1), 1000)
    return () => clearInterval(interval)
  }, [session])

  return useMemo(() => {
    void tick
    if (!session) {
      return {
        isImpersonating: false,
        sessionId: null,
        impersonatorName: null,
        targetName: null,
        expiresAt: null,
        isExpired: false,
        remainingMs: 0,
      }
    }
    const serverNow =
      session.serverNow + (Date.now() - session.verifiedAt)
    const remainingMs = Math.max(0, session.expiresAt - serverNow)
    return {
      isImpersonating: true,
      sessionId: session.sessionId,
      impersonatorName: session.actorName,
      targetName: session.targetName,
      expiresAt: session.expiresAt,
      isExpired: remainingMs === 0,
      remainingMs,
    }
  }, [session, tick])
}

export default useImpersonationSession
